/** Input shared by the platform and wing weighing forms — the two stacks are
 *  deliberately parallel (different field shapes per ADR-040), so only the
 *  genuinely identical mechanics live here. */

export function ScaleInput({
  value,
  onChange,
  disabled,
}: {
  value: number;
  onChange: (v: number) => void;
  disabled?: boolean;
}) {
  return (
    <input
      type="number"
      inputMode="decimal"
      step="0.1"
      value={value === 0 ? "" : value}
      disabled={disabled}
      onChange={(e) => {
        const v = e.target.value === "" ? 0 : parseFloat(e.target.value);
        onChange(Number.isFinite(v) ? v : 0);
      }}
      className="w-full px-1.5 py-1.5 text-sm text-right tabular-nums border border-input bg-card rounded focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:bg-muted/50 disabled:text-muted-foreground"
    />
  );
}

/** Text sibling of ScaleInput — same border/focus/disabled treatment. */
export function TextInput({
  value,
  onChange,
  placeholder,
  maxLength,
  disabled,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
}) {
  return (
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      maxLength={maxLength}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-2 py-1.5 text-sm border border-input bg-card rounded focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring disabled:bg-muted/50 disabled:text-muted-foreground"
    />
  );
}
